import { useMemo } from 'react';
import type { CaseBattleListItemResponse } from '../../services/generated/Api';
import { useProfile } from '../../queries/useProfileQueries';
import { isLiveInLobby, isShowing } from './battleModel';
import { useCaseBattlePrefs } from './CaseBattleSettingsSheet';
import { useStableOrder } from './lobbyOrder';

interface LobbyItems {
  items: CaseBattleListItemResponse[] | undefined;
  filteredOut: boolean;
}

export const useLobbyItems = (lobby: CaseBattleListItemResponse[] | undefined, now: number): LobbyItems => {
  const { affordableOnly, hideRunning } = useCaseBattlePrefs();
  const { data: profile } = useProfile();
  const balance = profile?.balanceInCredits;

  const live = useMemo(() => lobby?.filter((b) => isLiveInLobby(b, now)), [lobby, now]);
  const visible = useMemo(
    () =>
      live?.filter(
        (b) =>
          b.mine ||
          ((!affordableOnly || balance === undefined || b.totalCost <= balance) && (!hideRunning || !isShowing(b, now))),
      ),
    [live, affordableOnly, hideRunning, balance, now],
  );
  const items = useStableOrder(visible);

  return { items, filteredOut: (live?.length ?? 0) > 0 && visible?.length === 0 };
};
